import TimerDTO from "./DTO/TimerDTO";

/**
 * @property timerElements Element[]
 * @property timers TimerDto[]
 * @property rows Array[]
 */
export default class Countdowns {
    constructor(countdown_timer_class = null) {
        this.timerElements = this.getTimersArray(countdown_timer_class);

        if (this.timerElements.length <= 0) {
            return;
        }

        this.squares = [];
        this.timers = [];
        this.createTimersAndRows();
    }

    getDefaultCountdownTimerClass() {
        return 'countdown-timer';
    }

    getTimersArray(countdown_timer_class = null) {
        return Array.from(document.getElementsByClassName(
            countdown_timer_class ?? this.getDefaultCountdownTimerClass()
        ));
    }

    createTimersAndRows() {
        const now = new Date();

        this.timerElements.forEach((timer) => {
            const timerRows = timer.querySelectorAll('& > li');

            if (timerRows.length !== 4) {
                throw new DOMException(`Timer expected 4 rows, ${timerRows.length} provided.`);
            }

            this.squares.push(Array.from(timerRows));

            const eventDate = timer.dataset.event;

            if (typeof eventDate !== 'string') {
                throw new DOMException('Missing timer event date dataset attribute.');
            }

            this.timers.push(new TimerDTO(eventDate, now));
        });
    }

    start() {
        setInterval(() => {
            this.timers.forEach((timer, index) => {
                const timerDto = this.timers[index];
                timerDto.nextTick();

                this.squares[index][0].firstChild.innerText = timerDto.days;
                this.squares[index][1].firstChild.innerText = timerDto.hours;
                this.squares[index][2].firstChild.innerText = timerDto.minutes;
                this.squares[index][3].firstChild.innerText = timerDto.seconds;
            });
        }, 1000);
    }
}
